import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Check from 'react-feather/dist/icons/check.js';

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';
import Popup from '../../Popup/Popup.jsx';
import UploadDropZone from '../../Form/Field/UploadDropZone.jsx';

import conf from '../../../conf.js';
import upload from './submit.js';

export default class UploadCvForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploading: false,
      errors: null,
      popup: false,
    };
  }

  static propTypes = {
    freelanceId: PropTypes.number.isRequired,
    cv: PropTypes.object,
    onSubmitSuccess: PropTypes.func
  };

  static defaultProps = {
    className: '',
    cv: null,
    onSubmitSuccess: () => {}
  };

  sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  onSubmit = async (data) => {
    this.setState({ uploading: true, errors: null });
    
    try {
      const cvResult = await upload({ freelance: this.props.freelanceId }, { body: data });
      this.setState({uploading: false});
      this.props.onUploadSuccess(cvResult.data);

      this.setState({popup: true, uploading: false});
      await this.sleep(1500);
      this.props.onSubmitSuccess();

      return cvResult.data;
    } catch (e) {
      console.warn(e);
      this.setState({errors: e.errors});
    } finally {
      this.setState({uploading: false, popup: false});
    }
  };

  render() {
    return (
      <div className={this.props.className}>
        <FormGlobalErrors errors={this.state.errors}/>
        <UploadDropZone
          className="cv-dropzone"
          input={{value: this.props.cv, name: 'uploadedFile'}}
          dropText="Téléverser mon CV en Drag'n'Drop"
          uploadText="Sélectionner mon CV"
          uploadModifyText="Modifier mon CV"
          onSubmit={this.onSubmit}
          maxSize={conf.server.uploadMaxSize}
          acceptText=".doc, .docx, .pdf"
          accept={conf.allowedMimeTypes.cv}
        >
          {this.props.cv ?
            <span>
              <a
                href={this.props.cv.original}
                onClick={(e) => e.stopPropagation()}
                target="_blank" rel="noopener noreferrer">Cliquez ici
              </a> pour visualiser le CV envoyé ({this.props.cv.name})
            </span> : ''
          }
        </UploadDropZone>
        <Loader visible={this.state.uploading}>Upload en cours...</Loader>
        <Popup visible={this.state.popup}>
          <Check size={50}/><br/>
          CV uploadé
        </Popup>
      </div>
    );
  }
}
